import MenuService from "../../core/components/menu/MenuService";
import MenuItem from "../../core/components/menu/MenuItem";
import i18n from '../../shared/i18n'
import Inventories from '../inventory/Inventory.module';
import Temporaries from "./temporary/TemporaryItems.module";
import ConditionRequests from "../condition-report-requests/ConditionReportRequest.module";
import PoliceBooks from "@/modules/police-books/PoliceBook.module";
import TransferNote from "../transfer-notes/TransferNote.module";

MenuService.addMenuItem(new MenuItem('/items', i18n.t('Stock'), 2, 'boxes', [
  Inventories.menuItem,
  Temporaries.menuItem,
  PoliceBooks.menuItem,
  ConditionRequests.menuItem,
  TransferNote.menuItem,
], ['OR', 'view_inventoryitem', 'view_temporaryinventoryitem', 'view_conditionreportrequest', 'view_transfernote'], [
  '/temporary/active',
  '/temporary/archived'
]));

const routes = [
  ...Inventories.routes,
  ...Temporaries.routes,
  ...ConditionRequests.routes,
  ...PoliceBooks.routes,
]
export {routes}
